import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Seo } from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

// Where a lost visitor most likely wanted to go.
const destinations = [
  { to: "/#services", label: "Our services", note: "Audits, remediation, VPATs and consulting." },
  { to: "/blog", label: "The blog", note: "Guides on WCAG, Indian law and audits." },
  { to: "/#contact", label: "Contact us", note: "Schedule an audit or ask a question." },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <Seo title="Page not found" path={location.pathname} noindex />
      <Navbar />
      <main id="main-content" tabIndex={-1} className="section-padding pt-32">
        <div className="mx-auto max-w-3xl">
          <p className="eyebrow mb-4">Error 404</p>
          <h1 className="mb-4 font-display text-4xl font-bold text-foreground md:text-5xl">
            We couldn&rsquo;t find that page
          </h1>
          <p className="mb-8 max-w-xl text-lg leading-relaxed text-muted-foreground">
            The address may have been mistyped, or the page may have moved. Here is where
            most people were headed.
          </p>
          <Button variant="hero" size="lg" className="mb-12 min-h-[44px]" asChild>
            <Link to="/">Return to home</Link>
          </Button>
          <ul className="grid list-none gap-6 sm:grid-cols-3">
            {destinations.map((d) => (
              <li key={d.to} className="border-t-2 border-foreground pt-4">
                <Link
                  to={d.to}
                  className="font-display text-lg font-bold text-foreground underline-offset-4 hover:text-primary hover:underline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus-ring rounded-sm"
                >
                  {d.label}
                </Link>
                <p className="mt-1 text-base text-muted-foreground">{d.note}</p>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
